// @flow
import React, { PureComponent } from "react";
import type { RaceProgram } from "@tvg/types/Race";
import mediator from "@tvg/mediator";
import type { Dispatch } from "redux";
import { bindAll, get } from "lodash";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import RaceSelector from "@tvg/atomic-ui/_templates/RaceSelector";
import RaceHeaderUtils from "@tvg/utils/RaceHeaderUtils";
import {
  setRaceSelectorModalStateAction,
  type Actions as ProgramActions
} from "@tvg/shared-actions/ProgramActions";
import {
  resetBetting,
  type Actions as BetActions
} from "@tvg/shared-actions/BetActions";

import { type Actions as HandicapStoreActions } from "@tvg/shared-actions/HandicappingStore";
import { type Actions as PoolsActions } from "../actions/poolsNInfo";

type Props = {
  dispatch: Dispatch<
    ProgramActions | PoolsActions | BetActions | HandicapStoreActions
  >,
  isOpen: boolean,
  trackCode: string,
  trackName: string,
  raceNumber: string,
  races: RaceProgram[],
  isVideoShown: boolean,
  channel: string,
  modalType: "bottom" | "right",
  isChangesShown: boolean
};

export const formatRacesData = (
  races: RaceProgram[],
  isChangesShown: boolean
) => {
  const raceData = [];
  if (races.length > 0) {
    for (let i = 0; i < races.length; i += 1) {
      const raceInfo = {
        raceId: get(races[i], "raceId"),
        mtp: get(races[i], "mtp"),
        postTime: get(races[i], "postTime"),
        raceStatus: get(races[i], "status"),
        isGreyhound: get(races[i], "isGreyhound"),
        trackName: get(races[i], "track.trackName"),
        trackAbbr: get(races[i], "track.trackCode"),
        raceNumber: get(races[i], "raceNumber"),
        description: get(races[i], "highlighted.description"),
        importanceLevel: RaceHeaderUtils.getImportanceLevel(
          get(races[i], "highlighted.style")
        ),
        raceInfo: RaceHeaderUtils.createRaceDataForHeader(
          races[i],
          isChangesShown
        )
      };
      raceData.push(raceInfo);
    }
  }
  return raceData;
};

export class RaceSelectorModalComponent extends PureComponent<Props> {
  static defaultProps = {
    isOpen: false,
    races: [],
    trackCode: "",
    trackName: "",
    raceNumber: "",
    isVideoShown: false,
    channel: "",
    modalType: "bottom",
    isChangesShown: false
  };

  constructor(props: Props): void {
    super(props);
    bindAll(this, ["closeModal", "onNavigation"]);
  }

  onNavigation() {
    this.props.dispatch(resetBetting());
    this.props.dispatch(setRaceSelectorModalStateAction(false));
    // $FlowFixMe
    document.body.classList.toggle("modal", false);
  }

  getModalTitle() {
    if (this.props.channel) {
      return `${this.props.channel} TV SCHEDULE`;
    }
    return `${this.props.trackCode} - RACE SCHEDULE`;
  }

  closeModal() {
    mediator.base.dispatch({
      type: "PPM_CLOSE_RACE_NAVIGATION",
      payload: {
        trackName: get(this.props, "trackName"),
        raceNumber: get(this.props, "raceNumber")
      }
    });
    this.props.dispatch(setRaceSelectorModalStateAction(false));
  }

  render() {
    const baseProps = {
      title: this.getModalTitle(),
      animation: this.props.modalType,
      isOpen: this.props.isOpen,
      onClose: this.closeModal,
      qaLabel: "modal-raceSelector"
    };

    const props =
      this.props.modalType === "bottom"
        ? {
            ...baseProps,
            isFullHeight: false,
            hasVideoOffset: this.props.isVideoShown,
            hasMaxHeight: true
          }
        : {
            ...baseProps,
            isFullWidth: false,
            offsetTop: 0,
            hasRoundedCorners: false
          };

    return (
      <ModalV2 {...props}>
        {() => (
          <div style={{ background: "white" }}>
            <RaceSelector
              channel={this.props.channel}
              races={formatRacesData(
                this.props.races,
                this.props.isChangesShown
              )}
              onNavigationCallback={this.onNavigation}
            />
          </div>
        )}
      </ModalV2>
    );
  }
}

export default RaceSelectorModalComponent;
